import FilesListBox from "./components/files_list_box/files_list_box.js";
import Header from "./components/header.js";
import ReportListBox from "./components/report_list_box/report_list_box.js";
import Spinner from "./components/spinner.js";
import h, { onInit } from "./core/createElement.js";
import Modal from "./core/modalEngine.js";
import { switchable_element } from "./utils.js";

export default function Home() {
    const
        shared = { full_spinner: switchable_element(<Spinner black={false} />) },
        modal_overlay = new Modal(() => "");

    const
        refresh_reports = () => shared.report_box.refresh_reports(),
        refresh_files = () => shared.file_list_box.refresh_files(),
        refresh_lists = async () => {
            await refresh_reports();
            await refresh_files();
        },
        highlight_report = async ({ id }) => {
            await shared.file_list_box.hightlight_on_overlay(id);
            modal_overlay.show().overlay_click_hide(e => { dismiss_report_highlight() });
        },
        dismiss_report_highlight = () => {
            modal_overlay.hide();
            shared.file_list_box.dismiss_hightlight();
            shared.report_box.dismiss_all_cards_highlights();
        };

    onInit(async () => {
        await shared.header.get_all_groups();
    });

    return (
        <section class="full-size flex-column">
            <Header shared={shared} refresh_with_group={refresh_lists} />

            <main class="main-container justify-center">
                <ReportListBox
                    shared={shared}
                    set_group={(g) => shared.header.select_group(g)}
                    name="report_box"
                    refresh_files={refresh_files}
                    onHighlight={highlight_report}
                    onDismissHighlight={dismiss_report_highlight}
                />

                <FilesListBox
                    shared={shared}
                    name="file_list_box"
                />
            </main>
            {shared.full_spinner.marker()}
        </section>
    );
};